// Components
import { Button } from '@tracklib/kit'
import { Input, Form, baseFormValidation } from 'components/form'

import styles from './inviteform.css'

type InviteFormProps = {
  /* Prop is only used in validate */

  /* eslint-disable */
  alreadyInvitedEmails: Array<string>

  /* eslint-enable  */
  onSubmit: () => Promise<Record<string, unknown>>
  placeholder: string
  buttonText: string
}

type Values = { email: string }

const validate = (values: Values, alreadyInvitedEmails: Array<string>) => {
  const errors = baseFormValidation({
    email: { fields: ['email'] },
    required: { fields: ['email'] },
  })(values)

  if (alreadyInvitedEmails.includes(values.email)) {
    errors.email = 'Email already invited!'
  }

  return errors
}

const InviteForm = ({
  onSubmit,
  placeholder = 'Email address',
  buttonText = 'Invite',
  alreadyInvitedEmails,
}: InviteFormProps): JSX.Element => {
  const initialValues: Values = { email: '' }
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      className={styles.wrapper}
      validate={values => validate(values, alreadyInvitedEmails)}
      formDoneDelay={3000}
    >
      {({ submitButtonProps, isDone }) => (
        <>
          <div className={styles.emailWrapper}>
            <Input name="email" label="E-mail" type="email" placeholder={placeholder} className={styles.inputWrapper} errorText="Error!" />
            <Button className={styles.button} successText="Invited!" datatesting="invite_button" {...submitButtonProps}>
              <span>{buttonText}</span>
            </Button>
          </div>
          <div
            className={styles.success}
            style={{
              visibility: isDone ? 'visible' : 'hidden',
              opacity: isDone ? 1 : 0,
            }}
          >{`${placeholder} has been invited!`}</div>
        </>
      )}
    </Form>
  )
}

export default InviteForm
